export const CertificacionesActionTypes = {
  API_RESPONSE_SUCCESS: '@@certificaciones/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@certificaciones/API_RESPONSE_ERROR',

  GET_CERTIFICACION: '@@certificaciones/GET_CERTIFICACION',
  LIST_CERTIFICACIONES: '@@certificaciones/LIST_CERTIFICACIONES',
  ADD_CERTIFICACION: '@@certificaciones/ADD_CERTIFICACION',
  UPDATE_CERTIFICACION: '@@certificaciones/UPDATE_CERTIFICACION',
  DELETE_CERTIFICACION: '@@certificaciones/DELETE_CERTIFICACION',

  RESET: '@@certificaciones/RESET'
}
